/*
 * @Author: Hyman Choi
 * @Date: 2021-02-03 12:04:29
 * @LastEditTime: 2021-10-27 17:08:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\mai\quizManagement\quizDetail.js
 */
import request from "@/utils/request";
import config from "@/utils/config";

/**
 *  获取单个答案详情
 *
 * @param {*} params
 */
export function getProblemDetail(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/One",
		method: "get",
		params,
	});
}

/**
 * @description: 获取问题文件列表
 * @param {*} params
 * @return {*}
 */
export function getProblemFileList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemFile/List",
		method: "get",
		params,
	});
}

/**
 * 后台问题文件添加
 * @param {Object} params
 */
export function addProblemFile(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemFile/Add",
		method: "post",
		data,
	});
}

/**
 * @description: 后台删除问题文件
 * @param {*} params
 * @return {*}
 */
export function deleteProblemFile(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemFile/Delete",
		method: "delete",
		params,
	});
}

/**
 * @description: 后台更新问题
 * @param {*} data
 * @return {*}
 */
export function updateProblem(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/Update",
		method: "post",
		data,
	});
}

/**
 * @description: 获取答案列表
 * @param {*} params
 * @return {*}
 */
export function getAnswerList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemAnswer/List",
		method: "get",
		params,
	});
}

/**
 * @description: 获取答案文件列表
 * @param {*} params
 * @return {*}
 */
export function getAnswerFileList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/AnswerFile/List",
		method: "get",
		params,
	});
}

/**
 * @description: 后台设置或者取消最佳答案状态
 * @param {*} params
 * @return {*}
 */
export function setBestOrNot(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemAnswer/BestOrNot",
		method: "post",
		data,
	});
}

/**
 * @description: 后台问答奖励麦粒
 * @param {*} data
 * @return {*}
 */
export function assignMai(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/AssignMai",
		method: "post",
		data,
	});
}

/**
 * @description: 删除或者恢复答案
 * @param {*} data
 * @return {*}
 */
export function deleteOrBackAnswer(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemAnswer/DeleteOrBack",
		method: "delete",
		params: params,
	});
}

/**
 * @description: 后台问题答案文件删除
 * @param {*} params
 * @return {*}
 */
export function deleteAnswerFile(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/AnswerFile/Delete",
		method: "delete",
		params: params,
	});
}

/**
 * @description: 获取问题邀请的专家列表集合
 * @param {*} params
 * @return {*}
 */
export function getExpertList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemExpert/List",
		method: "get",
		params,
	});
}

/**
 * 后台问题邀请专家
 * @param {Object} data
 */
export function addExpert(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/ProblemExpert/Add",
		method: "post",
		data,
	});
}


/**
 * 后台删除问题下的专家用户
 * @param {Object} params
 */
export function deleteExpert(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/Expert/Delete",
		method: "delete",
		params: params,
	});
}

/**
 * @description: 后台分页获取指定答案评论集合
 * @param {*} params
 * @return {*}
 */
export function getAnswerCommentList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/AnswerComment/List",
		method: "get",
		params,
	});
}

/**
 * @description: 后台分页获取指定答案评论下的回复集合
 * @param {*} params
 * @return {*}
 */
export function getAnswerCommentReplyList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminProblem/AnswerComment/Reply/List",
		method: "get",
		params,
	});
}
